@let bot = config()?.bot;

<div
    class="p-6 overflow-auto messages flex-1 relative bg-primary-100"
    #messageWrapper>
    @for (message of messages(); track $index; let first = $first) {
        <div
            [class]="{
                'mt-4': !first,
            }">
            <big-chat-bot-message
                [message]="message"
                (errorButtonClick)="errorButtonClick($event)"
                (buttonClick)="buttonClick($event)"/>
        </div>
    }
</div>
<big-chat-rating class="block px-6 py-2 text-end bg-primary-100"/>
<big-chat-input/>
@if (bot?.showUserNote) {
    <div class="bg-primary-100 top-0 bottom-0 left-0 right-0 p-6 overflow-auto bg-alt overlay absolute">
        <div class="p-6 bg-white flex flex-col items-center rounded-md">
            <h4 class="mb-1">{{ bot?.disclaimer?.title }}</h4>
            <p>
                <!-- TODO: add nl2br pipe -->
                {{ bot?.disclaimer?.text }}
            </p>
            <big-ui-button
                [buttonStyle]="'primary'"
                (clicked)="toggleUseNote()">
                <span>{{ bot?.disclaimer?.button }}</span>
            </big-ui-button>
        </div>
    </div>
}
